import { Injectable } from '@angular/core';
import { StatisticQueryDto } from '@osos/shared/api';
import {
  StatisticQueryDtoRelatedDataModel,
  StatisticQueryPresenterModel,
} from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class StatisticQueryParserService extends ParserBase<
  StatisticQueryDto,
  StatisticQueryPresenterModel
> {
  constructor() {
    super(StatisticQueryDto, StatisticQueryPresenterModel, 1);
  }

  getPresenterModel(model: StatisticQueryDto): StatisticQueryPresenterModel {
    // Calculate sourceOptions flags
    const sourceOptionsWithFlags = this.calculateSourceOptionsFlags(
      model.sourceOptions,
    );

    const presenter = {
      specificationVersion: this.version,
    } as StatisticQueryPresenterModel;
    presenter.id = model.id;
    presenter.name = model.name;
    presenter.description = model.description;
    presenter.chartType = model.chartType;
    presenter.icon = model.icon;
    presenter.orderBy = model.orderBy;
    presenter.aggregation = model.aggregation;
    presenter.filterField = model.filterField;
    presenter.dataEntity = model.dataEntity;
    presenter.showAs = model.showAs;
    presenter.source = model.source;
    presenter.sourceOptions = sourceOptionsWithFlags;
    presenter.options = model.options;
    presenter.showInEntityOverview = model.showInEntityOverview;
    presenter.relatedData =
      model.relatedData as StatisticQueryDtoRelatedDataModel;
    return presenter;
  }
  getDataModel(presenter: StatisticQueryPresenterModel): StatisticQueryDto {
    // Calculate sourceOptions flags
    const sourceOptionsWithFlags = this.calculateSourceOptionsFlags(
      presenter.sourceOptions,
    );

    const model = {
      specificationVersion: this.version,
      name: presenter.name,
      description: Object.keys(presenter.description ?? {}).every(
        (k) => !presenter.description[k],
      )
        ? undefined
        : presenter.description,
      icon: presenter.icon,
      chartType: presenter.chartType,
      orderBy: presenter.orderBy,
      dataEntity: presenter.dataEntity,
      aggregation: presenter.aggregation,
      showAs: presenter.showAs,
      filterField: presenter.filterField,
      source: presenter.source,
      sourceOptions: sourceOptionsWithFlags,
      options: presenter.options
        ? { colors: presenter.options.colors }
        : undefined,
      showInEntityOverview: presenter.showInEntityOverview,
    } as StatisticQueryDto;

    return model;
  }

  /**
   * Calculate sourceOptions flags based on source parameters
   * Similar to data-views-parser but for statistic queries (no FilterFirst support)
   */
  private calculateSourceOptionsFlags(sourceOptions: any): any {
    if (!sourceOptions) {
      return sourceOptions;
    }

    const parameters = sourceOptions.sourceParameters || [];
    const hasParameters = parameters.length > 0;

    // If no parameters, reset sourceOptions to clear any existing parameter data
    if (!hasParameters) {
      return {
        isParameterized: false,
        sourceParameters: [],
      };
    }

    return {
      ...sourceOptions,
      isParameterized: hasParameters,
    };
  }
}
